import React from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import Logo from "../Logo";
import { BOOK_ON_DEMAND_URL } from "../../config/links";

const MobileDrawer = ({ open, setOpen, navItems, openTour }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] bg-white lg:hidden flex flex-col overscroll-contain">
      <div className="flex items-center justify-between h-[72px] px-5 border-b border-line shrink-0">
        <Logo />
        <button onClick={() => setOpen(false)} aria-label="Close menu">
          <X className="w-6 h-6 text-ink" />
        </button>
      </div>
      <nav className="flex flex-col px-6 pt-4 overflow-y-auto flex-1">
        {navItems.map((item) => (
          <Link
            key={item.label}
            to={item.to}
            className="font-serif-display text-3xl text-ink py-4 border-b border-line hover:text-camel transition-colors"
          >
            {item.label}
          </Link>
        ))}
      </nav>
      <div className="shrink-0 p-6 flex flex-col gap-3 border-t border-line">
        <a
          href={BOOK_ON_DEMAND_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-center py-3.5 rounded-full border border-ink text-ink label-caps text-[12px] btn-press"
        >
          Book On-Demand
        </a>
        <button onClick={() => { setOpen(false); openTour(); }} data-testid="mobile-book-tour-btn" className="text-center py-3.5 rounded-full bg-ink text-white label-caps text-[12px] btn-press">
          Book a Tour
        </button>
      </div>
    </div>
  );
};

export default MobileDrawer;
